import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import App from "./containers/App/index";
import { unregister } from "./registerServiceWorker";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import bugsnag from "bugsnag-js";
import createPlugin from "bugsnag-react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard.css";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

const bugsnagClient = bugsnag({
  apiKey: "8c5a745a71d3caff4d38098d7ac17dfa",
  releaseStage: process.env.REACT_APP_BUGSNAG_RELEASE_STAGE
});
const ErrorBoundary = bugsnagClient.use(createPlugin(React));

unregister();

const target = document.querySelector("#root");
const promise = loadStripe(process.env.REACT_APP_STRIPE_PK);

render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistStore(store)}>
      <Elements stripe={promise}>
        <BrowserRouter>
          <Switch>
            <Route path="/" name="Home" component={App} />
          </Switch>
        </BrowserRouter>
        </Elements>
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
  target
);
